import React from 'react';
import { makeStyles } from '@material-ui/core';
import Page from 'src/components/Page';
import Hero from './Hero';
import Features from './Features';
import CTA from './CTA';
import getFlagValue from 'src/utils/configUtil';

const useStyles = makeStyles(() => ({
  root: {}
}));

function HomeView() {
  const classes = useStyles();
  const isMaintenanceEnabled = getFlagValue(process.env.REACT_APP_MAINTENANCE_ENABLED ?? '');

  return (
    <Page
      className={classes.root}
      title="Home"
    >
      <Hero/>
      {!isMaintenanceEnabled && (
        <>
          <Features />
          <CTA />
        </>)}
    </Page>
  );
}

export default HomeView;
